import React, {useState, useEffect} from 'react'
import { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
function BlogsForm({ handler, isLoading, isSent, hasError, captchaKey}:any, ) {
    const initialFormState = {
    'your-name': '',
    'your-email': '',
    'your-phone': '',
    'your-company': '',
    'your-message': '',
    };

    const [formState, setFormState] = useState(initialFormState);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [showEmptyError, setShowEmptyError] = useState(false);
    const [gReCaptchaToken, setGReCaptchaToken] = useState<string | null>(null);
    const formRef = useRef<HTMLFormElement>(null);
    const handleFieldChange = (
    field: string,
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
    setFormState({
        ...formState,
        [field]: e.target.value,
    });
    };
    const handleCaptchaChange = (token: string | null) => {
        setGReCaptchaToken(token);
    };
    const recaptchaRef = useRef<ReCAPTCHA>(null);

    const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
      
        const { 'your-phone': phone, 'your-message': describe, ...otherFormFields } = formState;
      
        // Check if other fields except 'your-phone' and 'your-message' are empty
        const isEmpty = Object.values(otherFormFields).some((value) => value === '');
        if (isEmpty) {
          setShowEmptyError(true);
          setSubmitSuccess(false);
          return;
        }
        // if (!gReCaptchaToken) {
        //     alert('Please complete the reCAPTCHA.');
        // return;
        // }
      
        setShowEmptyError(false);
        handler(e, formState);
      
        // Reset form fields after successful submission
        setSubmitSuccess(true);
      
        // Reset form fields using the form reference
        if (formRef.current) {
          formRef.current.reset();
          setFormState(initialFormState);
          setGReCaptchaToken(null);

          // Reset the reCAPTCHA component using its ref
          if (recaptchaRef.current) {
            recaptchaRef.current.reset();
          }

        }
      };      
  
    return (
        <>
          {isSent && submitSuccess &&  <div className="alert alert-success" role="alert">Thank you for filling out your information!...</div>}
           
            <form  ref={formRef} onSubmit={handleFormSubmit} className='blog_form'>
                <h2>get in touch</h2>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="input_wraper">
                            <input id='name' type="text" placeholder='Full Name*' name="your-name" onChange={(e) => handleFieldChange("your-name", e)} />
                            {showEmptyError && formState['your-name'] === '' && <p className='error_red'>Please fill in this required field.</p>}
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="input_wraper">
                            <input id='email' type="email" placeholder='Email*' name="your-email" onChange={(e) => handleFieldChange("your-email", e)} />
                            {showEmptyError && formState['your-email'] === '' && <p className='error_red'>Please fill in this required field.</p>}
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="input_wraper">
                            <input id='phone' type="number" placeholder='Telephone' name="your-phone" onChange={(e) => handleFieldChange("your-phone", e)} />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="input_wraper">
                            <input id='company' type="text" placeholder='Company*' name="your-company" onChange={(e) => handleFieldChange("your-company", e)} />
                            {showEmptyError && formState['your-company'] === '' && <p className='error_red'>Please fill in this required field.</p>}
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="input_wraper">
                            <textarea name="your-message" placeholder='Message' id="describe" onChange={(e) => handleFieldChange("your-message", e)}></textarea>
                        </div>
                    </div>
                    <ReCAPTCHA size="invisible" ref={recaptchaRef} sitekey={captchaKey} onChange={handleCaptchaChange} />
                    <div className="col-lg-12">
                        <div className="input_wraper button_wraper1 mt-3">
                            <input className='cmn_btn m-0' type="submit" value='Submit' />
                            {isLoading &&  
                                <div className="spinner-border text-light" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </form>
            
        </>
    )
  }

  export default BlogsForm;